module.exports = __webpack_public_path__ + "37eb4669.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_ser_courier.png
// module id = 1798
// module chunks = 0